//https://www.fareez.info/create-your-own-autocomplete-using-vuejs-2/
let filterLib = {
    props: {
        value: {
            type: String,
            required: true
        },
        suggestions: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            open: false,
            current: 0
        }
    },
    directives: {
        clickaway
    },
    computed: {
        // Filtering the suggestion based on the input
        matches() {
            return this.suggestions.filter((obj) => {
                return obj.title.toLowerCase().indexOf(this.value.toLowerCase()) >= 0
            })
        },
        openSuggestion() {
            return this.selection !== '' &&
                this.matches.length !== 0 &&
                this.value !== '' &&
                this.open === true
        }
    },
    methods: {
        updateValue(value) {
            if (this.open === false) {
                this.open = true
                this.current = 0
            }
            this.$emit('input', value)
            this.$root.callfilters(event)
        },
        // When enter pressed on the input
        enter() {
            // this.$emit('input', this.matches[this.current].title)
            event.preventDefault();
            window.location = this.matches[this.current].url
            this.open = false
        },
        // When up pressed while suggestions are open
        up() {
            if (this.current > 0) {
                this.current--
            }
        },
        // When up pressed while suggestions are open
        down() {
            if (this.current < this.matches.length - 1) {
                this.current++
            }
        },
        // For highlighting element
        isActive(index) {
            return index === this.current
        },
        // When one of the suggestion is clicked
        suggestionClick(index) {
            // this.$emit('input', this.matches[index].title)
            event.preventDefault();
            window.location = this.matches[index].title
            this.open = false
        },
        clickAway() {
            this.open = false
        }
    },
    template: `
    <div class="filter-block filter-lib" :class="{'is-active':open}" v-clickaway="clickAway">
        <input class="filterlibevent form-control" type="search" :value="value" @input="updateValue($event.target.value)" placeholder="Rechercher..."
          @keydown.enter = 'enter'
          @keydown.down = 'down'
          @keydown.up = 'up'
          @keydown.esc = 'clickAway'
        >
        <ul class="filters filter-content dropdown-menu">
            <li v-for="(suggestion, index) in matches"
                class="filter"
                :class="{'selected': isActive(index)}"
                @click="suggestionClick(index)"
            >
              <a :href="suggestion.url">{{ suggestion.title }}</a>
            </li>
        </ul>
    </div>`
}